export const heroData = {
  tag: '🔥 实时更新 · 每日新鲜',
  h1: '51吃瓜网今日吃瓜资源',
  h1Sub: '每日最新爆料黑料合集',
  slogan: '吃瓜一线，不落人后。全网热点，一站掌握。',
  description: '51吃瓜网今日吃瓜资源是全网领先的娱乐八卦与热点事件聚合平台，专注于每日最新吃瓜爆料与黑料合集。我们全天候追踪娱乐圈动态、社会热点、网红翻车与明星八卦，以视频、图文和快讯形式实时呈现。无论是最新爆出的猛料，还是持续发酵的热门事件，这里都是你获取一手资讯的首选阵地。',
  description2: '当前站内覆盖影视综艺、网红主播、明星名人与社会话题四大板块，每日更新超过50条独家内容，热门话题实时追踪不停歇。',
  stats: [
    { label: '每日爆料', value: '50+' },
    { label: '视频合集', value: '1000+' },
    { label: '话题追踪', value: '24h' },
  ],
  primaryCta: { text: '立即吃瓜', href: '#media' },
  secondaryCta: { text: '热门话题', href: '#topics' },
};

export const mediaItems = [
  {
    id: 'm1',
    title: '某顶流男星深夜密会神秘女子，疑似新恋情曝光',
    duration: '03:25',
    views: '128.6万',
    date: '2小时前',
    tag: '独家',
    thumbnail: 'https://readdy.ai/api/search-image?query=dark%20cinematic%20entertainment%20news%20thumbnail%20style%2C%20mysterious%20atmosphere%20with%20warm%20red%20accent%20lighting%2C%20paparazzi%20night%20scene%20vibe%2C%20abstract%20background%20with%20dramatic%20shadows%2C%20bold%20editorial%20design%2C%20breaking%20news%20aesthetic%2C%20high%20contrast%20with%20deep%20blacks%20and%20crimson%20highlights%20on%20dark%20surface&width=640&height=360&seq=media-thumb-001&orientation=landscape',
  },
  {
    id: 'm2',
    title: '知名女星片场耍大牌全记录，工作人员愤然爆料',
    duration: '05:18',
    views: '96.3万',
    date: '5小时前',
    tag: '热议',
    thumbnail: 'https://readdy.ai/api/search-image?query=film%20set%20behind%20scenes%20dramatic%20lighting%2C%20warm%20spotlight%20on%20dark%20stage%2C%20cinematic%20production%20atmosphere%2C%20professional%20camera%20equipment%20silhouettes%2C%20moody%20contrast%20with%20amber%20and%20crimson%20tones%2C%20entertainment%20industry%20vibe%2C%20editorial%20photography%20style%20with%20dark%20background&width=640&height=360&seq=media-thumb-002&orientation=landscape',
  },
  {
    id: 'm3',
    title: '某综艺节目后台争执曝光，选手与导师激烈对峙',
    duration: '02:47',
    views: '87.1万',
    date: '8小时前',
    tag: '热榜',
    thumbnail: 'https://readdy.ai/api/search-image?query=television%20studio%20backstage%20dramatic%20tension%2C%20warm%20stage%20lights%20in%20dark%20environment%2C%20reality%20show%20production%20set%20vibe%2C%20contrasting%20shadows%20and%20highlights%2C%20entertainment%20news%20editorial%20style%2C%20crimson%20and%20gold%20accent%20lighting%20on%20dark%20surface&width=640&height=360&seq=media-thumb-003&orientation=landscape',
  },
  {
    id: 'm4',
    title: '最新娱乐圈合约纠纷独家揭秘，天价违约金内幕',
    duration: '04:52',
    views: '73.8万',
    date: '12小时前',
    tag: '独家',
    thumbnail: 'https://readdy.ai/api/search-image?query=legal%20document%20dramatic%20lighting%20with%20warm%20crimson%20glow%2C%20mysterious%20office%20atmosphere%2C%20confidential%20papers%20aesthetic%2C%20dark%20wood%20desk%20with%20golden%20accent%20light%2C%20investigative%20journalism%20style%2C%20high%20contrast%20editorial%20photography%2C%20dramatic%20shadows&width=640&height=360&seq=media-thumb-004&orientation=landscape',
  },
  {
    id: 'm5',
    title: '热门网红翻车现场完整版，直播口误引发全网热议',
    duration: '06:33',
    views: '152.4万',
    date: '1天前',
    tag: '爆款',
    thumbnail: 'https://readdy.ai/api/search-image?query=live%20streaming%20studio%20setup%20dramatic%20lighting%2C%20ring%20light%20glow%20in%20dark%20room%2C%20social%20media%20influencer%20aesthetic%2C%20warm%20crimson%20and%20amber%20color%20scheme%2C%20modern%20streaming%20equipment%20silhouette%2C%20entertainment%20news%20editorial%20style%2C%20dark%20moody%20background&width=640&height=360&seq=media-thumb-005&orientation=landscape',
  },
];

export const faqItems = [
  {
    id: 'f1',
    q: '51吃瓜网今日吃瓜资源是什么？',
    a: '51吃瓜网今日吃瓜资源是一个专注于娱乐八卦与热点事件聚合的在线平台，每日更新最新爆料、黑料合集、热门事件视频，提供51吃瓜在线观看和51今日吃瓜的实时资讯服务，让你随时随地掌握第一手热点动态。',
  },
  {
    id: 'f2',
    q: '这里的吃瓜内容多久更新一次？',
    a: '我们全天候实时追踪娱乐圈和社会热点，每天至少更新50条以上最新爆料内容。从事件发生到上线通常不超过2小时，热门话题持续跟进直至尘埃落定，确保你不错过任何一个精彩瞬间。',
  },
  {
    id: 'f3',
    q: '如何快速找到我感兴趣的话题？',
    a: '你可以通过首页的话题标签区浏览不同分类的热门话题，也可以使用排行榜查看当前讨论度最高的事件。所有内容按时间线和热度双重排序，方便你快速定位最想看的吃瓜内容。',
  },
  {
    id: 'f4',
    q: '51吃瓜网的爆料内容来源可靠吗？',
    a: '我们坚持多方交叉验证原则，所有爆料内容均标注信息来源和可信度等级。对于未经证实的传闻明确标注"待核实"，已确认的独家爆料标注"已证实"，让用户清晰了解每条信息的可靠程度。',
  },
];

export const updatesItems = [
  { id: 'u1', time: '10分钟前', content: '某选秀节目冠军被曝与经纪公司解约，双方各执一词，最新进展持续追踪中', tag: '最新' },
  { id: 'u2', time: '28分钟前', content: '热门综艺录制现场突发意外，节目组紧急发布声明回应公众关切', tag: '快讯' },
  { id: 'u3', time: '1小时前', content: '知名导演新片选角内幕曝光，多位一线明星参与试镜竞争激烈', tag: '独家' },
  { id: 'u4', time: '2小时前', content: '某短视频平台头部网红账号被封，疑似涉及违规内容引发行业震动', tag: '热议' },
  { id: 'u5', time: '3小时前', content: '年度音乐盛典获奖名单提前泄露，主办方表示将追查泄密源头', tag: '爆料' },
  { id: 'u6', time: '5小时前', content: '娱乐圈金童玉女被拍同框出游，粉丝群炸锅热议是否官宣在即', tag: '追踪' },
  { id: 'u7', time: '7小时前', content: '某影视公司内部邮件曝光，揭示行业潜规则引发全网讨论', tag: '深度' },
];

export const commentsItems = [
  {
    id: 'c1',
    avatar: 'https://readdy.ai/api/search-image?query=simple%20abstract%20profile%20avatar%20circle%2C%20warm%20crimson%20gradient%20minimal%20design%2C%20dark%20background%20with%20soft%20red%20glow%2C%20modern%20clean%20style%2C%20no%20face%20no%20text&width=80&height=80&seq=comment-avatar-01&orientation=squarish',
    name: '吃瓜一线猹',
    date: '2小时前',
    content: '这个爆料太震撼了！我等这条瓜等了整整一周，终于有实锤了。51吃瓜网的速度真的快，全网第一个发的吧？',
    likes: '2.3k',
  },
  {
    id: 'c2',
    avatar: 'https://readdy.ai/api/search-image?query=simple%20abstract%20profile%20avatar%20circle%2C%20warm%20amber%20gradient%20minimal%20design%2C%20dark%20background%20with%20soft%20gold%20glow%2C%20modern%20clean%20style%2C%20no%20face%20no%20text&width=80&height=80&seq=comment-avatar-02&orientation=squarish',
    name: '八卦探测仪',
    date: '5小时前',
    content: '每天不刷一遍51吃瓜就感觉错过了全世界，这里的视频合集整理得太好了，一条看完所有重点。',
    likes: '1.8k',
  },
  {
    id: 'c3',
    avatar: 'https://readdy.ai/api/search-image?query=simple%20abstract%20profile%20avatar%20circle%2C%20warm%20crimson%20and%20amber%20gradient%20minimal%20design%2C%20dark%20background%20with%20soft%20warm%20glow%2C%20modern%20clean%20style%2C%20no%20face%20no%20text&width=80&height=80&seq=comment-avatar-03&orientation=squarish',
    name: '真相挖掘机',
    date: '8小时前',
    content: '追了三年瓜，这个站的信息整理能力是真的强。时间线清晰，视频合集完整，每次都能把来龙去脉理得明明白白。',
    likes: '3.1k',
  },
];

export const topicsItems = [
  { id: 't1', name: '顶流恋情', heat: '🔥 986万' },
  { id: 't2', name: '综艺翻车', heat: '🔥 754万' },
  { id: 't3', name: '合约纠纷', heat: '🔥 682万' },
  { id: 't4', name: '网红翻车', heat: '🔥 621万' },
  { id: 't5', name: '选秀黑幕', heat: '🔥 598万' },
  { id: 't6', name: '明星塌房', heat: '🔥 543万' },
  { id: 't7', name: '影视爆料', heat: '🔥 487万' },
  { id: 't8', name: '直播事故', heat: '🔥 429万' },
  { id: 't9', name: '代言风波', heat: '🔥 376万' },
  { id: 't10', name: '片场八卦', heat: '🔥 312万' },
];

export const rankingItems = [
  { id: 'r1', rank: 1, title: '某顶流男星深夜密会神秘女子事件全记录', heat: '1286万', trend: 'up', change: '+128' },
  { id: 'r2', rank: 2, title: '热门网红直播翻车完整版视频流出', heat: '1152万', trend: 'up', change: '+96' },
  { id: 'r3', rank: 3, title: '知名女星片场耍大牌工作人员实名爆料', heat: '963万', trend: 'up', change: '+73' },
  { id: 'r4', rank: 4, title: '综艺节目后台争执录音曝光持续发酵', heat: '871万', trend: 'up', change: '+58' },
  { id: 'r5', rank: 5, title: '娱乐圈合约纠纷天价违约金内幕揭秘', heat: '738万', trend: 'same', change: '+12' },
  { id: 'r6', rank: 6, title: '年度盛典获奖名单提前泄露引发争议', heat: '654万', trend: 'up', change: '+45' },
  { id: 'r7', rank: 7, title: '影视公司内部邮件揭示行业潜规则', heat: '521万', trend: 'down', change: '-23' },
];

export const featuresItems = [
  {
    id: 'fe1',
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '全天候24小时实时监测娱乐圈动态，从事件爆发到上线平均仅需2小时，让你快人一步掌握最新爆料。',
  },
  {
    id: 'fe2',
    icon: 'ri-stack-line',
    title: '全集整理',
    desc: '每条热点事件都配有完整时间线和视频合集，不再碎片化吃瓜。一键回顾事件全程，来龙去脉一目了然。',
  },
  {
    id: 'fe3',
    icon: 'ri-shield-check-line',
    title: '可信标注',
    desc: '每条爆料明确标注信息来源和可信度等级，已证实、待核实一目了然，拒绝虚假传闻误导大众。',
  },
];

export const contactData = {
  title: '投稿爆料',
  description: '如果你有独家线索或最新爆料，欢迎通过以下方式联系我们。所有投稿严格保密，一经采用将获得丰厚奖励。',
  email: 'tougao@51chigua.com',
  tips: '投稿请注明信息来源，附相关证据将优先处理。我们承诺24小时内回复所有有效线索。',
};

export const aboutData = {
  title: '关于51吃瓜网',
  content: '51吃瓜网今日吃瓜资源成立于2022年，是国内领先的娱乐八卦与热点事件聚合平台。我们秉持"吃瓜一线，不落人后"的理念，致力于为用户提供最新、最全、最可靠的吃瓜资讯服务。平台汇聚了超过1000条独家视频合集，每日更新50条以上的最新爆料，覆盖影视综艺、网红主播、明星名人与社会话题四大核心板块。我们坚持多方验证、透明标注的原则，让每一位用户都能放心吃瓜、安心交流。',
};

export const indexItems = [
  { id: 'i1', title: '明星恋情专题', desc: '最新绯闻、官宣、分手全记录', count: '32条', icon: 'ri-heart-pulse-line' },
  { id: 'i2', title: '综艺翻车合集', desc: '节目事故与后台争执汇总', count: '28条', icon: 'ri-emotion-sad-line' },
  { id: 'i3', title: '网红塌房档案', desc: '直播翻车与账号封禁追踪', count: '45条', icon: 'ri-user-unfollow-line' },
  { id: 'i4', title: '合约纠纷揭秘', desc: '天价违约金与解约内幕', count: '19条', icon: 'ri-file-text-line' },
  { id: 'i5', title: '选秀黑幕曝光', desc: '投票造假与暗箱操作实录', count: '24条', icon: 'ri-spy-line' },
  { id: 'i6', title: '影视行业潜规则', desc: '内部邮件与匿名爆料集合', count: '16条', icon: 'ri-movie-2-line' },
  { id: 'i7', title: '代言风波全览', desc: '品牌解约与代言人争议', count: '21条', icon: 'ri-briefcase-line' },
  { id: 'i8', title: '直播事故实录', desc: '各平台直播翻车现场完整版', count: '37条', icon: 'ri-live-line' },
  { id: 'i9', title: '片场八卦汇总', desc: '剧组日常与演员幕后爆料', count: '29条', icon: 'ri-camera-line' },
];

export const appData = {
  title: '随时随地，掌上吃瓜',
  description: '51吃瓜网移动端专属入口已上线！无需下载，浏览器访问即可享受与桌面端完全一致的吃瓜体验。支持夜间模式、推送提醒和离线缓存，让你走到哪吃到哪。',
  features: ['极速加载', '夜间模式', '推送提醒', '离线缓存'],
};

export const cardsItems = [
  {
    id: 'cd1',
    title: '深度调查：某选秀节目背后的资本博弈与暗箱操作',
    excerpt: '一场看似公平的选秀背后，隐藏着怎样的资本游戏？我们独家获取的内部文件揭示了惊人真相……',
    date: '3小时前',
    tag: '深度',
    image: 'https://readdy.ai/api/search-image?query=investigative%20journalism%20dramatic%20lighting%2C%20dark%20office%20with%20warm%20crimson%20accent%20light%2C%20confidential%20documents%20on%20desk%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style%2C%20deep%20shadows%20with%20golden%20highlights%2C%20professional%20news%20magazine%20aesthetic&width=640&height=400&seq=card-img-001&orientation=landscape',
  },
  {
    id: 'cd2',
    title: '独家揭秘：某顶流代言品牌背后的利益链条与天价合同',
    excerpt: '一份被泄露的代言合同揭示了明星代言的真实运作模式，数字之大令人瞠目结舌……',
    date: '6小时前',
    tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=luxury%20brand%20contract%20signing%20dramatic%20scene%2C%20dark%20elegant%20room%20with%20warm%20amber%20lighting%2C%20golden%20pen%20on%20paper%2C%20mysterious%20business%20atmosphere%2C%20editorial%20photography%2C%20crimson%20and%20gold%20color%20scheme%2C%20high%20contrast%20shadows&width=640&height=400&seq=card-img-002&orientation=landscape',
  },
  {
    id: 'cd3',
    title: '全程回顾：某综艺录制现场意外事件的完整时间线梳理',
    excerpt: '从意外发生到官方回应，我们按分钟整理了整个事件的全部经过，还原每一个关键节点……',
    date: '9小时前',
    tag: '梳理',
    image: 'https://readdy.ai/api/search-image?query=television%20production%20set%20dramatic%20emergency%20scene%2C%20dark%20studio%20with%20warm%20red%20alert%20lights%2C%20professional%20crew%20silhouettes%2C%20tense%20atmosphere%2C%20editorial%20news%20style%2C%20high%20contrast%20with%20crimson%20highlights%2C%20documentary%20photography&width=640&height=400&seq=card-img-003&orientation=landscape',
  },
  {
    id: 'cd4',
    title: '网红生态调查：从一夜爆红到全网翻车的48小时纪实',
    excerpt: '一位拥有千万粉丝的网红如何在48小时内从巅峰跌入谷底？我们还原了整个事件的完整经过……',
    date: '1天前',
    tag: '调查',
    image: 'https://readdy.ai/api/search-image?query=social%20media%20influencer%20downfall%20dramatic%20scene%2C%20dark%20room%20with%20phone%20screen%20glow%2C%20notification%20alerts%20visual%20metaphor%2C%20warm%20crimson%20and%20amber%20mood%20lighting%2C%20editorial%20documentary%20style%2C%20high%20contrast%20emotional%20atmosphere&width=640&height=400&seq=card-img-004&orientation=landscape',
  },
  {
    id: 'cd5',
    title: '年度盘点：2026上半年娱乐圈十大最劲爆事件全记录',
    excerpt: '从明星塌房到综艺翻车，从合约纠纷到代言风波，上半年的娱乐圈堪称一波未平一波又起……',
    date: '2天前',
    tag: '盘点',
    image: 'https://readdy.ai/api/search-image?query=year%20in%20review%20entertainment%20news%20collage%20dramatic%20lighting%2C%20dark%20background%20with%20warm%20golden%20and%20crimson%20highlights%2C%20newspaper%20headlines%20aesthetic%2C%20editorial%20magazine%20style%2C%20top%20stories%20visual%2C%20bold%20typographic%20elements%2C%20dramatic%20composition&width=640&height=400&seq=card-img-005&orientation=landscape',
  },
];

export const carouselItems = [
  {
    id: 'cl1',
    title: '某顶流恋情风暴',
    subtitle: '全程追踪 · 独家视频合集',
    excerpt: '独家视频记录某顶流男星从深夜密会到公开回应的完整时间线，包含多角度实拍画面与知情人士深度访谈。',
    tag: '本周最热',
    image: 'https://readdy.ai/api/search-image?query=breaking%20news%20entertainment%20headline%20dramatic%20composition%2C%20dark%20background%20with%20warm%20crimson%20spotlight%20effect%2C%20paparazzi%20night%20photography%20style%2C%20bold%20editorial%20design%2C%20mysterious%20celebrity%20silhouette%2C%20glamorous%20yet%20secretive%20atmosphere%2C%20magazine%20cover%20quality%2C%20dramatic%20shadows&width=1200&height=600&seq=carousel-img-001&orientation=landscape',
  },
  {
    id: 'cl2',
    title: '综艺翻车大合集',
    subtitle: '2026上半年 · 经典名场面',
    excerpt: '盘点上半年综艺节目中最令人瞠目结舌的翻车名场面，从导师互怼到选手失控，每一帧都是名场面。',
    tag: '热门合集',
    image: 'https://readdy.ai/api/search-image?query=reality%20show%20dramatic%20moment%20collage%20style%2C%20dark%20stage%20with%20warm%20golden%20spotlights%2C%20television%20studio%20atmosphere%2C%20entertainment%20drama%20visual%2C%20bold%20editorial%20design%20with%20crimson%20accents%2C%20high%20energy%20composition%2C%20dynamic%20lighting%20effects&width=1200&height=600&seq=carousel-img-002&orientation=landscape',
  },
  {
    id: 'cl3',
    title: '网红塌房全景',
    subtitle: '深度调查 · 从爆红到翻车',
    excerpt: '三位头部网红在短短一周内相继翻车，背后折射出的是整个行业的系统性风险与流量焦虑。',
    tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=social%20media%20crisis%20dramatic%20visual%2C%20dark%20background%20with%20fractured%20phone%20screens%20metaphor%2C%20warm%20crimson%20and%20amber%20warning%20lights%2C%20digital%20downfall%20concept%2C%20editorial%20magazine%20style%2C%20dramatic%20contrast%2C%20bold%20composition%20with%20deep%20shadows&width=1200&height=600&seq=carousel-img-003&orientation=landscape',
  },
  {
    id: 'cl4',
    title: '合约纠纷内幕',
    subtitle: '独家揭秘 · 天价违约金真相',
    excerpt: '多位明星与经纪公司的合约纠纷集中爆发，我们深入调查了天价违约金背后的行业规则与利益链条。',
    tag: '独家专题',
    image: 'https://readdy.ai/api/search-image?query=legal%20contract%20dispute%20dramatic%20visual%2C%20dark%20boardroom%20with%20warm%20golden%20accent%20lighting%2C%20torn%20paper%20documents%20scattered%2C%20corporate%20drama%20atmosphere%2C%20editorial%20business%20magazine%20style%2C%20crimson%20and%20amber%20color%20scheme%2C%20high%20contrast%20professional%20photography&width=1200&height=600&seq=carousel-img-004&orientation=landscape',
  },
];

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '最新快讯', href: '#updates' },
  { label: '深度爆料', href: '#cards' },
  { label: '焦点专题', href: '#carousel' },
  { label: '热门话题', href: '#topics' },
  { label: '吃瓜问答', href: '#faq' },
  { label: '视频速递', href: '#media' },
];

export const footerData = {
  intro: '51吃瓜网今日吃瓜资源 — 每日最新爆料黑料合集，51吃瓜在线观看与51今日吃瓜、51每日吃瓜的首选平台。汇聚全网最热娱乐八卦与热点事件，实时更新，一站掌握。',
  sections: [
    {
      title: '快速导航',
      links: [
        { label: '视频速递', href: '#media' },
        { label: '最新快讯', href: '#updates' },
        { label: '深度爆料', href: '#cards' },
        { label: '焦点专题', href: '#carousel' },
        { label: '热门话题', href: '#topics' },
        { label: '吃瓜问答', href: '#faq' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '平台介绍', href: '#about' },
        { label: '联系我们', href: '#contact' },
        { label: '移动端入口', href: '#app' },
        { label: '专题索引', href: '#index' },
      ],
    },
  ],
  partners: { title: '合作伙伴', empty: true },
  copyright: '© 2026 51吃瓜网今日吃瓜资源. All Rights Reserved.',
};